// Returns the user's first name plus first surname (e.g. "Pedro Júlio Costa Silva" -> "Pedro Júlio")
export const getUserDisplayName = (fullName) => {
  if (!fullName) return "";

  const [firstName, firstSurname] = fullName.trim().split(/\s+/);

  return [firstName, firstSurname].filter(Boolean).join(" ");
};
